import React from 'react'
import './index.css'
import Section from 'components/Section'
import classNames from 'classnames'
import TryOtherItemsYourSquadLoved from 'containers/TryOtherItemsYourSquadLoved/components/index.js'

export default function OtherItemsYourSquadLoved (props) {
  return (
    <Section
      className={
          classNames({
            'quick-shop-other-items-your-squad-loved': true
          })
        }
    >
      <TryOtherItemsYourSquadLoved productVariant={props?.productVariant} />
    </Section>
  )
}
